import { trackGA4Login } from "@/lib/analytics/ga4/ecommerce";
import { trackConversion } from "@/lib/analytics/track-conversion";

export type SignInSurface = "password" | "magic_code" | "email_verification";

export function reportSignInConversion(isNew: boolean, surface: SignInSurface): void {
  if (isNew) {
    trackConversion("user_signed_up", { surface });
    return;
  }
  trackGA4Login("workos");
}
